import React, { useContext } from 'react';
import Head from 'next/head';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { WEBSITE_CDN } from 'utils/config';
import { MarketContext } from 'providers/market';

import OgTags from './OgTags/OgTags';
import AppleTags from './AppleTags/AppleTags';
import TwitterTags from './TwitterTags/TwitterTags';

interface MetatagsProps {
  urlPath?: string;
  title?: string;
  desc?: string;
  keywords?: string;
  noIndex?: boolean;
}

const Metatags = ({ urlPath = '', title: customTitle, desc, keywords, noIndex = false }: MetatagsProps) => {
  const { t } = useTranslation();
  const { marketCode } = useContext(MarketContext);

  const url = `https://support.spotify.com/${marketCode}/${urlPath}`;
  const title = customTitle || t('title_tag_default');

  return (
    <>
      <Head>
        <title>{title} - Spotify</title>
        <link rel="icon" href={`${WEBSITE_CDN}/favicon.png`} />
        <link rel="canonical" href={url} />
        {desc && <meta name="description" content={desc} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {noIndex && <meta name="robots" content="noindex" />}
      </Head>

      <OgTags url={url} title={title} desc={desc} />
      <TwitterTags url={url} title={title} desc={desc} />
      <AppleTags />
    </>
  );
};

export default Metatags;
